import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import "./Product.css";

import Tea from "../image/Tea.jpg";
import Coffee from "../image/Coffee.jpg";
import Boost from "../image/Boost.jpg";
import Sanackes from "../image/Sanackes.jpg";
import Sandwich from "../image/sandwichs.jpg";
import CoolDrink from "../image/Cool drink.jpg";
import Milk from "../image/Milk.jpg";

export default function Product({ search = "" }) {
    const navigate = useNavigate();
    const [showAll, setShowAll] = useState(false);

    const drinks = [
        {
            id: 1,
            image: Tea,
            name: "Tea",
            category: "Hot Drinks",
            description: "Freshly brewed and perfectly refreshing"
        },
        {
            id: 2,
            image: Coffee,
            name: "Coffee",
            category: "Hot Drinks",
            description: "Rich coffee with a smooth aroma"
        },
        {
            id: 3,
            image: Milk,
            name: "Milk",
            category: "Fresh Drinks",
            description: "Fresh and creamy goodness"
        },
        {
            id: 4,
            image: Boost,
            name: "Boost",
            category: "Energy Drinks",
            description: "A delicious drink for your energy"
        },
        {
            id: 5,
            image: Sanackes,
            name: "Snacks",
            category: "Quick Bites",
            description: "Crispy and tasty snacks"
        },
        {
            id: 6,
            image: Sandwich,
            name: "Sandwich",
            category: "Quick Bites",
            description: "Freshly prepared tasty sandwich"
        },
        {
            id: 7,
            image: CoolDrink,
            name: "Cool Drink",
            category: "Cold Drinks",
            description: "Chilled and refreshing cool drink"
        }
    ];

    const filteredDrinks = drinks.filter((item) =>
        item.name
            .toLowerCase()
            .includes(search.trim().toLowerCase())
    );

    const isSearching = search.trim() !== "";

    const displayedDrinks = isSearching
        ? filteredDrinks
        : showAll
            ? drinks
            : drinks.slice(0, 3);

    const openProduct = (name) => {
        navigate(`/menu/${encodeURIComponent(name)}`);
    };

    return (
        <section className="products-section">
            <Container>

                {isSearching && (
                    <div className="search-title">
                        <span className="products-eyebrow">
                            SEARCH
                        </span>

                        <h2>Search Results</h2>

                        <p>
                            Results for "{search}"
                        </p>
                    </div>
                )}

                

                <div className="products-grid">

                    {displayedDrinks.length > 0 ? (

                        displayedDrinks.map((item) => (

                            <article
                                className="product-card"
                                key={item.id}
                                onClick={() => openProduct(item.name)}
                            >

                                <div className="product-image-wrap">

                                    <img
                                        src={item.image}
                                        alt={item.name}
                                        className="product-image"
                                    />

                                    <div className="product-image-overlay">
                                        <span>
                                            View Product
                                        </span>
                                    </div>

                                    <div className="product-number">
                                        {String(item.id).padStart(2, "0")}
                                    </div>

                                </div>

                                <div className="product-content">

                                    <span className="product-category">
                                        {item.category}
                                    </span>

                                    <h3>
                                        {item.name}
                                    </h3>

                                    <p>
                                        {item.description}
                                    </p>

                                    <button
                                        type="button"
                                        className="product-link"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            openProduct(item.name);
                                        }}
                                    >
                                        <span>
                                            Explore Product
                                        </span>

                                        <span className="product-arrow">
                                            →
                                        </span>
                                    </button>

                                </div>

                            </article>

                        ))

                    ) : (

                        <div className="no-search-result">

                            <div className="no-result-icon">
                                ×
                            </div>

                            <h3>
                                No Products Found
                            </h3>

                            <p>
                                No product matches "{search}".
                            </p>

                        </div>

                    )}

                </div>

                {!isSearching && (
                    <div className="products-more">

                        <button
                            type="button"
                            className="ProductButton"
                            onClick={() => setShowAll(!showAll)}
                        >
                            <span>
                                {showAll ? "Show Less" : "View All Products"}
                            </span>

                            <span>
                                {showAll ? "↑" : "→"}
                            </span>
                        </button>

                    </div>
                )}

            </Container>
        </section>
    );
}